import type { ExpandableItem, LinkItem, SubLinkItem } from './types';

// A link/sub-link is active when the pathname starts with one of its prefixes,
// or — when it declares none — on an exact pathname match. Placeholder links
// (href "#") are never active.
export function isLinkActive(item: LinkItem | SubLinkItem, pathname: string): boolean {
  if (item.disabled || item.href === '#') return false;
  if (item.activePrefixes && item.activePrefixes.length > 0) {
    return item.activePrefixes.some((prefix) => pathname.startsWith(prefix));
  }
  return pathname === item.href;
}

// An expandable is active when any of its prefixes match.
export function isExpandableActive(item: ExpandableItem, pathname: string): boolean {
  return item.activePrefixes.some((prefix) => pathname.startsWith(prefix));
}

// Mirrors Phlex: a section starts expanded exactly when it is active.
export function isExpandableInitiallyExpanded(
  item: ExpandableItem,
  pathname: string,
): boolean {
  return isExpandableActive(item, pathname);
}

// Today's date in ISO (YYYY-MM-DD) for the Capacities deep-link, matching the
// Phlex `serving_date=#{Date.current.iso8601}` query. Uses the browser's LOCAL
// date — `toISOString()` would emit the UTC date, which lands a day early for
// UTC+ timezones (e.g. before 8am in Singapore) and links to the wrong day.
export function todayServingDate(): string {
  const now = new Date();
  const pad = (n: number) => String(n).padStart(2, '0');
  return `${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(now.getDate())}`;
}

// Resolve a sub-link's href, appending the serving-date query when required.
export function resolveHref(item: SubLinkItem): string {
  if (item.appendServingDate) {
    return `${item.href}?serving_date=${todayServingDate()}`;
  }
  return item.href;
}
